document.addEventListener("DOMContentLoaded", function() {
    var backToTop = document.getElementById('backToTop');
    if (!backToTop) return;

    backToTop.addEventListener('click', function(event) {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
});